/** Muss mit CsvTableExportHelper.MAX_CALCULATED_PRICE_EXPORT_ROWS im Backend übereinstimmen. */
export const MAX_TABLE_EXPORT_ROWS = 10000;

export function isExportCountWithinLimit(count) {
    const numericCount = Number(count);
    if (!Number.isFinite(numericCount) || numericCount < 0) {
        return true;
    }
    return numericCount <= MAX_TABLE_EXPORT_ROWS;
}
